import React, { useEffect, useState } from "react";
import solutions1 from "../assets/PNG/solutions1.png";
import solutions2 from "../assets/PNG/solutions2.png";
import solutions3 from "../assets/PNG/solutions3.png";
// import solutions4 from "../assets/PNG/solutions4.png";
// import solutions5 from "../assets/PNG/solutions5.png";
import solutions6 from "../assets/PNG/solutions6.png";
import solutions7 from "../assets/PNG/solutions7.png";
// import solutions8 from "../assets/PNG/solutions8.png";

import solutions1MB from "../assets/PNG/solutions1MB.png";
import solutions2MB from "../assets/PNG/solutions2MB.png";
import solutions3MB from "../assets/PNG/solutions3MB.png";
// import solutions4MB from "../assets/PNG/solutions4MB.png";
// import solutions5MB from "../assets/PNG/solutions5MB.png";
import solutions6MB from "../assets/PNG/solutions6MB.png";
import solutions7MB from "../assets/PNG/solutions7MB.png";
// import solutions8MB from "../assets/PNG/solutions8MB.png";

import svg1 from "../assets/SVG/pen.svg";
import svg2 from "../assets/SVG/person.svg";
import svg3 from "../assets/SVG/bank.svg";
import svg4 from "../assets/SVG/eco.svg";
// import svg5 from "../assets/SVG/manager.svg";
// import svg6 from "../assets/SVG/group.svg";
// import svg7 from "../assets/SVG/salary.svg";
// import svg8 from "../assets/SVG/doc.svg";
import { NavLink } from "react-router-dom";

const Solutions: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  return (
    <div className="solutions">
      <div className="solutions__1 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
        <div className="solutions__1__container">
          <div className="solutions__1__container__title">
            Leonext offers a wide array of services tailor made for demanding
            businesses that stand out from the competition
          </div>
          <div className="solutions__1__container__text">
            Growing a business is not an easy task without the right resources.
            Leonext is always by your side offering high quality services to
            empower your business because we believe in your vision.
          </div>
          <NavLink to="/login">
            <div className="solutions__1__container__button ps-6">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
        {isMobile ? (
          <div className="flex w-full justify-end">
            <img className="w-[90%] " src={solutions1MB}></img>
          </div>
        ) : (
          <img src={solutions1}></img>
        )}
        <div className="solutions__1__greenBar"></div>
      </div>
      {isMobile ? (
        <div className="solutions__2 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
          <img className="w-[90%]" src={solutions2MB} alt="photo" />
          <div>
            <div className="flex flex-col gap-6 w-full items-center pt-8">
              <div className="solutions__2__title">
                Crypto to FIAT conversion
              </div>
              <div className="solutions__2__text w-[90%]">
                Leonext offers fast, comfortable and secure fiat to crypto or
                crypto to fiat conversions, allowing you to focus on all the
                important aspects of your business strategies. Our easy-to-use
                online platform gives you access to main currencies including
                Euro, US Dollar, British Pound. Leonext enables you to exchange
                your Bitcoins (BTC), Ethereum (ETH), Tether (USDT) and USDC with
                fiat currencies and vice versa with just a few clicks.
              </div>
              {/* 
              <div className="flex flex-col gap-2 items-center">
                <div className="solutions__2__text">
                  Check out some of the most popular currency pairs:
                </div>
                <div className="flex justify-around gap-4">
                  <div className="solutions__2__currency">EUR / USD</div>
                  <div className="solutions__2__currency">USD / JPY</div>
                  <div className="solutions__2__currency">GBP / USD</div>
                  <div className="solutions__2__currency">AUD / USD</div>
                </div>
              </div> */}
              <div className="solutions__2__text">
                Leonext cutting edge technology allows our clients to make the
                necessary conversions in a quick and efficient way, minimising
                delays and helping your business stay ahead of the competition.
                Leonext’s team has designed a simple and straightforward
                registration process for you:
              </div>
            </div>
          </div>
          <div className="flex gap-4 mt-[2rem] justify-center flex-wrap">
            <div className="solutions__2__info">
              <img className="w-[4rem]" src={svg1}></img>
              <div className="solutions__2__text !text-left">
                Register in LeoNext. exchange
              </div>
              <div className="solutions__2__info__number">1</div>
            </div>
            <div className="solutions__2__info">
              <img className="w-[4rem]" src={svg2}></img>
              <div className="solutions__2__text !text-left">
                Verify your account by following a simple and straightforward
                Know Your Business (KYB) process
              </div>
              <div className="solutions__2__info__number">2</div>
            </div>
            <div className="solutions__2__info">
              <img className="!w-[4rem]" src={svg3}></img>
              <div className="solutions__2__text !text-left">
                Fill in your bank account details and crypto wallets
              </div>
              <div className="solutions__2__info__number">3</div>
            </div>
            <div className="solutions__2__info">
              <img className="w-[4rem]" src={svg4}></img>
              <div className="solutions__2__text !text-left">
                Make the conversions you need in line with your business goals
              </div>
              <div className="solutions__2__info__number">4</div>
            </div>
          </div>
          <NavLink to="/login">
            {" "}
            <div className="solutions__1__container__button mt-[3rem] cursor-pointer">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
      ) : (
        <div className="solutions__2 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
          <div className="flex gap-24 justify-between items-end">
            <img src={solutions2} alt="photo" />
            <div className="flex flex-col gap-6">
              <div className="solutions__2__title">
                Crypto to FIAT conversion
              </div>
              <div className="solutions__2__text">
                Leonext offers fast, comfortable and secure fiat to crypto or
                crypto to fiat conversions, allowing you to focus on all the
                important aspects of your business strategies. Our easy-to-use
                online platform gives you access to main currencies including
                Euro, US Dollar, British Pound. Leonext enables you to exchange
                your Bitcoins (BTC), Ethereum (ETH), Tether (USDT) and USDC with
                fiat currencies and vice versa with just a few clicks.
              </div>

              {/* <div className="flex flex-col gap-2">
                <div className="solutions__2__text">
                  Check out some of the most popular currency pairs:
                </div>
                <div className="solutions__2__currency">EUR / USD</div>
                <div className="solutions__2__currency">USD / JPY</div>
                <div className="solutions__2__currency">GBP / USD</div>
                <div className="solutions__2__currency">AUD / USD</div>
              </div> */}
              <div className="solutions__2__text">
                Leonext cutting edge technology allows our clients to make the
                necessary conversions in a quick and efficient way, minimising
                delays and helping your business stay ahead of the competition.
                Leonext’s team has designed a simple and straightforward
                registration process for you:
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-[2rem]">
            <div className="solutions__2__info">
              <img src={svg1}></img>
              <div>Register in LeoNext. exchange</div>
              <div className="solutions__2__info__number">1</div>
            </div>
            <div className="solutions__2__info">
              <img src={svg2}></img>
              <div>
                Verify your account by following a simple and straightforward
                Know Your Business (KYB) process
              </div>
              <div className="solutions__2__info__number">2</div>
            </div>
            <div className="solutions__2__info">
              <img src={svg3}></img>
              <div>Fill in your bank account details and crypto wallets</div>
              <div className="solutions__2__info__number">3</div>
            </div>
            <div className="solutions__2__info">
              <img src={svg4}></img>
              <div>
                Make the conversions you need in line with your business goals
              </div>
              <div className="solutions__2__info__number">4</div>
            </div>
          </div>
          <NavLink to="/login">
            {" "}
            <div className="solutions__1__container__button mt-[3rem]">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
      )}
      <div className="solutions__3 gap-24 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col-reverse ">
        <div className="flex flex-col gap-12 px-4">
          <div className="solutions__3__title">OTC Desk Services</div>
          <div className="solutions__3__text">
            Leonext is a financial services hub, designed to simplify
            complicated transactions that otherwise could weigh on your
            financial plans. <br />
            <br />A wide range of OTC services is available to satisfy even the
            most demanding clients. By using blockchain technology advanced
            tools we can facilitate a multitude of financial transactions faster
            and in an efficient way. For VIP clients who would like to use our
            services with a larger than usual volume of trade, Leonext’s team is
            ready to listen carefully to your needs and provide tailor made
            solutions that stand out from the competition.
          </div>
          <NavLink to="/login">
            {" "}
            <div className="solutions__1__container__button !justify-start ps-6  max-[899px]:m-auto max-[899px]:ps-0">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
        {isMobile ? (
          <div className="w-full flex justify-end">
            <img className="z-[2] w-[90%]" src={solutions3MB} alt="photo" />
          </div>
        ) : (
          <img className="z-[2]" src={solutions3} alt="photo" />
        )}
        <div className="solutions__3__greenBar"></div>
      </div>
      {/* <div className="solutions__4 gap-24 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col">
        {isMobile ? (
          <div className="w-full flex justify-start">
            <img className="w-[90%]" src={solutions4MB} alt="photo" />
          </div>
        ) : (
          <img src={solutions4} alt="photo" />
        )}
        <div className="flex flex-col gap-8">
          <div className="solutions__4__title">Crypto Loan</div>
          <div className="solutions__4__text">
            Cryptocurrencies have changed the way we see finance forever.
            Businesses may need loans to finance various projects and generate
            growth. While banks still try to catch up with the needs of modern
            businessmen, Leonext embraces the power of cryptocurrencies by
            offering a unique crypto loan service. The process is designed to be
            quick and smooth, relieving you from unnecessary stress.
          </div>
          <div className="solutions__4__text flex justify-between items-center gap-8">
            <div className="w-[18rem] relative ps-[2.5rem] max-[1440px]:w-fit">
              <div className="absoluteQuestion">?</div>
              <span>Crypto Investor?</span>
              <br />
              You have crypto assets like BTC, ETH, USDT and want to leverage
              them for a loan.
            </div>
            <span>OR</span>
            <div className="w-[18rem] relative ps-[2.5rem] max-[1440px]:w-fit">
              <div className="absoluteQuestion">?</div>
              <span>Need Fiat Currency?</span>
              <br />
              As a borrower, you require fiat currency but can repay your loan
              with crypto assets.
            </div>
          </div>
          <div className="solutions__4__text">
            Leonext facilitates a seamless three-party agreement, ensuring
            smooth conversion, hedging rates, and secure money transfers. After
            the loan term, we manage the conversion back to crypto, ensuring a
            hassle-free process for both lenders and borrowers.
          </div>
          <NavLink to="/login">
            {" "}
            <div className="solutions__1__container__button !justify-start ps-6 max-[899px]:m-auto max-[899px]:ps-0">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
      </div> */}
      {/* <div className="solutions__5  gap-24 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col-reverse">
        <div className="flex flex-col gap-8">
          <div className="solutions__5__title">
            Purchasing Real Estate With Crypto
          </div>
          <div className="solutions__5__text">
            Real estate is considered by some a safe haven type of investment,
            capable of withstanding most market downturns. Purchasing real
            estate helps you diversify your investment portfolio. With Leonext,
            cryptocurrency holders can use crypto to buy the real estate of
            their dreams. How can you invest in property by paying with crypto?
            Leonext enables you to do it in 4 easy steps.
          </div>
          <div className="solutions__5__text flex flex-col gap-8">
            <div className="flex gap-8 ps-8">
              <img src={svg5} alt="photo" />
              You declare your ability to buy property and sign a Property Sale
              Agreement (PSA) with the real estate seller.{" "}
            </div>
            <div className="flex gap-8 ps-8">
              <img src={svg8} alt="photo" />
              You sign a crypto sale agreement (CPA) with Leonext, based on
              which Client sells cryptocurrencies for agreed price.
              Consequently, you transfer the agreed amount of cryptocurrencies
              to Leonext's wallet address.{" "}
            </div>
            <div className="flex gap-8 ps-8">
              <img src={svg6} alt="photo" />
              Leonext, you and the real estate seller sign a Remittance
              Agreement, based on which you instruct Leonext to make a payment
              directly to the bank account of the real estate seller.
            </div>
            <div className="flex gap-8 ps-8">
              <img src={svg7} alt="photo" />
              Transaction is completed, when the real estate seller confirms in
              writing the acceptance of payment.{" "}
            </div>
          </div>
          <NavLink to="/login">
            <div className="solutions__1__container__button !justify-start ps-6  max-[899px]:m-auto max-[899px]:ps-0">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
        {isMobile ? (
          <div className="w-full flex justify-end">
            <img className="w-[90%]" src={solutions5MB} />
          </div>
        ) : (
          <img className="pt-[3rem]" src={solutions5} />
        )}
      </div> */}
      <div className="solutions__4 gap-24 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col">
        {isMobile ? (
          <div className="w-full flex">
            <img className="w-full" src={solutions6MB} alt="photo" />{" "}
          </div>
        ) : (
          <img src={solutions6} alt="photo" />
        )}
        <div className="flex flex-col gap-8">
          <div className="solutions__4__title">Liquidity provider</div>
          <div className="solutions__4__text">
            Liquidity challenges in the cryptocurrency market can impact trading
            efficiency and price stability. Market fragmentation, thin order
            books and regulatory uncertainty related to some jurisdictions can
            deter market participants, including institutional investors and
            market makers, from providing liquidity.
          </div>

          <div className="solutions__4__text">
            When becoming a Leonext client, liquidity stops being a problem.
            Leonext clients can access large liquidity pools from multiple
            established sources such as Binance, LMax and many others. By
            aggregating liquidity from multiple sources, Leonext is able to
            increase the market depth it offers to its clients and therefore
            deliver better fills on the order flow when compared to working with
            a single liquidity provider.
          </div>
          <NavLink to="/login">
            <div className="solutions__1__container__button !justify-start ps-6 max-[899px]:m-auto max-[899px]:ps-0">
              Get Started{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </div>
          </NavLink>
        </div>
      </div>
      <div className="solutions__6 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
        <div className="solutions__6__greenBar"></div>
        <div className="flex pt-[8rem] max-[899px]:flex-col-reverse">
          <div className="flex flex-col justify-end gap-12">
            <div className="solutions__6__title">B2B Legal Support</div>
            <div className="solutions__6__text">
              Navigating the complex world of cryptocurrency trading could be a
              challenge for all businesses without the right kind of legal
              support. At Leonext, we acknowledge the importance of legal
              support therefore we have worked hard to offer top notch legal
              support to B2B clients by forming a team of seasoned
              professionals.
              <br />
              <br />
              A company engaging in business-to-business (B2B) transactions
              involving cryptocurrencies should have legal support for several
              reasons:
              <br />
              <br />
              Regulatory Compliance: The cryptocurrency regulatory landscape is
              complex and evolving. B2B transactions involving cryptocurrencies
              may be subject to various regulations depending on the
              jurisdiction, including anti-money laundering (AML), know your
              customer (KYC), and securities laws. Legal support can help ensure
              compliance with these regulations to avoid penalties and legal
              risks.
              <br />
              <br />
              Contractual Agreements: B2B transactions typically involve
              contractual agreements between parties. Legal support is essential
              for drafting, reviewing, and negotiating contracts related to
              cryptocurrency transactions to protect your interest and ensure
              that the terms are enforceable and legally sound.
            </div>
          </div>
          {isMobile ? (
            <div className="w-full flex justify-end">
              <img className="w-[90%]" src={solutions7MB}></img>
            </div>
          ) : (
            <img src={solutions7}></img>
          )}
        </div>
        <br />
        <br />
        <div className="solutions__6__text">
          Risk Management: Trading cryptocurrencies involves inherent risks,
          including price volatility, cybersecurity threats, and regulatory
          uncertainty. Legal experts can help identify and assess these risks
          and mitigate them, such as implementing appropriate risk disclosures
          and insurance policies.
          <br />
          <br />
          Dispute Resolution: If any dispute or conflict arises from B2B
          cryptocurrency transactions, legal support can facilitate resolution
          through negotiation, mediation, arbitration, or litigation. Having
          experienced legal counsel can help your company navigate the legal
          process efficiently and effectively to protect your interests.
        </div>
        <br />
        <br />
        <NavLink to="/login">
          <div className="solutions__1__container__button !justify-start ps-6 pb-8 max-[899px]:m-auto max-[899px]:ps-0">
            Get Started{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                fill="#35BCAB"
              />
            </svg>
          </div>
        </NavLink>
      </div>
      {/* <div className="solutions__7 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
        <div className="flex gap-24 max-[899px]:flex-col">
          <div className="flex flex-col gap-8">
            {isMobile ? (
              <div className="w-full flex">
                <img className="w-[90%]" src={solutions8MB} />
              </div>
            ) : (
              <img src={solutions8} />
            )}
            {isMobile ? (
              <Fragment />
            ) : (
              <div className="solutions__7__text">
                With our platform, you can effortlessly facilitate{" "}
                <span>secure and efficient cryptocurrency transactions</span>{" "}
                while maintaining brand consistency. Join the ranks of
                forward-thinking enterprises leveraging the power of digital
                currencies.
              </div>
            )}
          </div>
          <div className="flex flex-col justify-end gap-8">
            <div className="solutions__7__title">Exchange as a Service</div>
            <div className="solutions__7__text">
              Elevate your business with our B2B-focused crypto-to-fiat and
              fiat-to-crypto exchange platform, offering a customizable white
              label solution. Seamlessly integrate our cutting-edge technology
              into your operations to unlock new revenue streams and enhance
              client services. How could your business benefit from a white
              label solution?
            </div>
            <div className="grid grid-cols-2 gap-4 max-[899px]:m-auto">
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4">
                White Label Solution: Customise the platform to align with your
                brand identity.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Revenue Opportunities: Expand your service offerings and attract
                new clients.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Enhanced Client Services: Provide seamless cryptocurrency
                transactions tailored to your clients' needs.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Security: Benefit from robust security measures to protect
                transactions and data.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Scalability: Grow your business with a flexible and scalable
                platform.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Competitive Edge: Stay ahead of the curve in the rapidly
                evolving cryptocurrency market.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Compliance Support: Ensure regulatory compliance with our
                comprehensive solution.
              </div>
              <div className="max-[899px]:text-xs max-[899px]:w-[11rem] w-[15rem] border-l-[0.5rem] border-l-[#35BCAB] ps-4 text-left">
                Dedicated Support: Access ongoing technical support.
              </div>
            </div>
            {isMobile ? (
              <div className="solutions__7__text">
                With our platform, you can effortlessly facilitate{" "}
                <span>secure and efficient cryptocurrency transactions</span>{" "}
                while maintaining brand consistency. Join the ranks of
                forward-thinking enterprises leveraging the power of digital
                currencies.
              </div>
            ) : (
              <Fragment />
            )}
          </div>
        </div>
        <NavLink to="/login">
          <div className="solutions__1__container__button mt-16 mb-16">
            Get Started{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                fill="#35BCAB"
              />
            </svg>
          </div>
        </NavLink>
      </div> */}
    </div>
  );
};

export default Solutions;
